import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { useIsDesktop } from '@service-initiation/shared-ui-breakpoints';
import { TranslationEntries } from '@service-initiation/tech-care-data-access-i18n';
import { useRepairMessageValue } from '@service-initiation/tech-care-data-access-store';
import { ClaimsOffRamp } from '@service-initiation/tech-care-ui-claims-off-ramp';

import otherDevicesImgDesktop from '../assets/other-device-images-desktop.png';
import otherDevicesImgMobile from '../assets/other-device-images-mobile.png';
import { TextArea } from './TextArea';

const OtherImageBase = styled.img`
  display: flex;
  align-self: center;
`;

const OtherImageMobile = styled(OtherImageBase)`
  max-width: 343px;
`;

const OtherImageDesktop = styled(OtherImageBase)`
  max-width: 100%;
`;

const OTHER_DEVICE_TEXTS = TranslationEntries.Repairs.OtherDevice;

export type OtherDeviceFormProps = {
  handleTextAreaChange: (value: string) => void;
};

export const OtherDeviceForm = ({
  handleTextAreaChange,
}: OtherDeviceFormProps) => {
  const repairMessage = useRepairMessageValue();

  const { t } = useTranslation();
  const isDesktop = useIsDesktop();

  const OtherImage = isDesktop ? OtherImageDesktop : OtherImageMobile;

  return (
    <>
      <TextArea
        data-testid="damage-text-area"
        label={t(OTHER_DEVICE_TEXTS.TextFieldLabel)}
        onChange={handleTextAreaChange}
        value={repairMessage}
      />
      <ClaimsOffRamp />
      <OtherImage
        alt="miscellaneous devices"
        data-testid="damage-other-image"
        src={isDesktop ? otherDevicesImgDesktop : otherDevicesImgMobile}
      />
    </>
  );
};
